<template>
  <audio-player
    :src="audioSrc"
    :time="aTime"
    :play="aPlayed"
    :volume="aVolume"
    @timeupdate="currentATime = $event"
  />
</template>

<script>
import AudioPlayer from "./AudioPlayer.vue";

// @group Audio
// Audio player synchronized to other (base) video player
export default {
  name: "SyncAudioPlayer",
  components: {
    AudioPlayer
  },
  props: {
    // Base player time
    playerTime: {
      type: Number,
      required: true
    },
    // Base player loading status
    playerLoading: {
      type: Boolean,
      required: true
    },
    // Base player paused status
    playerPaused: {
      type: Boolean,
      required: true
    },
    // Synchronized player start time in seconds (relative to base player start)
    startTime: {
      type: Number,
      default: 0
    },
    // Synchronized player source
    audioSrc: {
      type: String,
      default: null
    },
    // Synchronized player duration in seconds
    audioDuration: {
      type: Number,
      default: 0
    },
    // Is synchronized player not-muted
    on: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      aTime: 0,
      currentATime: 0,
      aPlayed: false,
      aVolume: 1,
      maxShift: 1
    };
  },
  computed: {
    // @vuese
    // Difference between current synchronized player time and base player time
    timeShift() {
      return Math.abs(this.playerTime - this.currentATime - this.startTime);
    },
    // @vuese
    // Current time is in range of synchronized sound
    timeInRange() {
      return (
        this.playerTime >= this.startTime &&
        this.playerTime < this.startTime + this.audioDuration
      );
    },
    // @vuese
    // Check that sound is need to be synchronized
    needSync() {
      return this.timeInRange && this.timeShift > 1;
    }
  },
  watch: {
    // @vuese
    // Start or stop player when base's loading status has changed
    playerLoading(loading) {
      if (loading) {
        this.aPlayed = false;
      } else if (!this.playerPaused && this.timeInRange) {
        this.aPlayed = true;
      }
    },
    // @vuese
    // Start or stop player when base's paused status has changed
    playerPaused(paused) {
      if (paused) {
        this.aPlayed = false;
      } else if (!this.playerLoading && this.timeInRange) {
        this.aPlayed = true;
      }
    },
    // @vuese
    // Sync time if it's needed
    playerTime() {
      if (this.needSync) {
        this.syncTime();
        if (!this.playerPaused && !this.playerLoading) {
          this.aPlayed = true;
        }
      }
    },
    // @vuese
    // Mute/unmute synchronized player
    on(on) {
      if (on) {
        this.aVolume = 1;
      } else {
        this.aVolume = 0;
      }
    }
  },
  methods: {
    // @vuese
    // Synchronize time
    syncTime() {
      this.aTime = this.playerTime - this.startTime;
    }
  }
};
</script>

<style></style>
